<form (ngSubmit)="search()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="formfield__no-label formfield__no-padding countryprofilesearch__search flex-fill">
    <input matInput placeholder="Search" [formControl]="searchControl">
    <mat-icon matSuffix svgIcon="search"></mat-icon>
  </mat-form-field>
</form>
